import {useEffect, useState} from 'react';

const headerIsMounted = {
	state: false,
	subscribers: [] as ((state: boolean) => void)[],
	next: (state: boolean) => {
		headerIsMounted.state = state;
		headerIsMounted.subscribers.forEach((fn) => fn(state));
	},
	subscribe: (fn: (state: boolean) => void) => {
		headerIsMounted.subscribers.push(fn);
		fn(headerIsMounted.state);

		return () => {
			headerIsMounted.subscribers = headerIsMounted.subscribers.filter((it) => it !== fn);
		};
	},
};

// TODO: Remove!!! use UseLayoutEffect
export function useHeaderState() {
	const [state, setState] = useState(false);

	const updateState = (state: boolean) => {
		headerIsMounted.next(state);
	};

	useEffect(() => {
		const unsubscribe = headerIsMounted.subscribe(setState);

		return () => {
			unsubscribe();
		};
	}, []);

	return {state, setState: updateState};
}
